<template>
  <b-modal
    id="user-wizard-modal"
    v-model="isWizardActive"
    title="User Wizard"
    hide-header
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    content-class="modal-user"
    :size="modalSize"
    @shown="onShown"
    @hidden="resetAll"
  >
    <div class="w-100 d-inline-flex title-user-wizard text-center mb-2">
      <h4
        class="text-capitalize text-center py-1"
        style="width: -webkit-fill-available; position: absolute"
      >
        {{ `Face Matcher` }}
      </h4>
      <feather-icon
        icon="XIcon"
        class="mr-2 ml-auto my-1"
        style="cursor: pointer; z-index: 1"
        size="24"
        @click="closeModal"
      />
    </div>

    <step-indicator :currentStep="currentStep" :numberedSteps="numberedSteps" />

    <!-- <h5 class="modal-title">{{ numberedSteps[currentStep] }}</h5> -->
    <div class="b-modal-body" :style="modalStyle">
      <face
        v-if="currentStep === 0 && !loading"
        ref="faceStepRef"
        @next-step="nextStep"
        :luna-master-account-options="lunaMasterAccountOptions"
        :luna-list-options="lunaListOptions"
      />

      <matcher
        v-if="currentStep === 1 && !loading"
        ref="matcherStepRef"
        :luna-master-account-id="lunaMasterAccountSelected"
        :face="face"
      />
    </div>
  </b-modal>
</template>

<script>
import { BModal, BSpinner } from "bootstrap-vue";
import StepIndicator from "./StepIndicator.vue";
import Face from "./Face.vue";
import Matcher from "./Matcher.vue";
import store from "@/store";
import { ref, computed, watch, nextTick, onMounted } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BModal,
    BSpinner,
    StepIndicator,
    Face,
    Matcher,
  },
  props: {
    isWizardActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit, parent }) {
    const currentStep = ref(0);
    const numberedSteps = ref(["Register", "Find"]);

    store.dispatch("luna_master_account/getAll");
    const lunaMasterAccountOptions = computed(
      () => store.getters["luna_master_account/getSelectedItems"]
    );

    store.dispatch("luna_list/getAll");
    const lunaListOptions = computed(() => store.getters["luna_list/getSelectedItems"]);

    const loading = ref(false);
    const face = ref(null);
    const lunaMasterAccountSelected = ref(null);

    const toast = useToast();

    const nextStep = (data) => {
      face.value = data.face;
      lunaMasterAccountSelected.value = data.lunaMasterAccountId;
      loading.value = false;
      currentStep.value++;
    };

    const onShown = () => {
      numberedSteps.value = ["Register", "Find"];
    };

    const closeModal = () => {
      emit("close-wizard");
    };

    const resetAll = () => {
      currentStep.value = 0;
    };

    const modalSize = computed(() => {
      return currentStep.value === 3 ? "xl" : "lg";
    });

    const modalStyle = computed(() => {
      if (currentStep.value === 3) {
        return {
          height: "60vh",
          overflowY: "auto",
        };
      } else {
        return {
          height: "60vh",
          overflowY: "auto",
        };
      }
    });

    return {
      face,
      currentStep,
      numberedSteps,
      nextStep,
      loading,
      closeModal,
      resetAll,
      onShown,
      modalSize,
      modalStyle,

      lunaMasterAccountOptions,
      lunaListOptions,
      lunaMasterAccountSelected,
    };
  },
};
</script>

<style scoped>
.close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 1.5rem;
  cursor: pointer;
}

.div-container {
  max-width: 80%;
  margin: auto;
}
</style>

<style>
.modal-user .modal-body {
  padding: 0 !important;
}
</style>
